<template>
  <audience-authorization edit-permission="aiTrain:auth:edit" />
</template>

<script>
import AudienceAuthorization from '../common/AudienceAuthorization'

export default {
  name: 'AiTrainAuth',
  components: { AudienceAuthorization }
}
</script>
